import * as React from 'react';
import { View } from 'react-native';
import { CardView } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { SettingsItemSwitch } from 'design-system/SettingsItem';
import { useNotificationsPermissions } from 'hooks/useNotificationsPermissions';
import { NotificationsPermissionState } from 'hooks/useNotificationPermissionTypes';
import { useNotificationsPreferences } from 'features/settings/notifications/hooks/useNotificationsPreferences';
import { useAppSelector } from 'store/hooks';
import { selectFeatureFlag } from 'reducers/selectors';
const AlertSection = () => {
    const { permissionState } = useNotificationsPermissions('invest');
    const { pushNormalizedNotificationPreferences: notificationPreferences, updatePreferences, isUpdating, } = useNotificationsPreferences(false);
    const [state, setState] = React.useState({
        volatilityAlerts: notificationPreferences['alerts.volatility.push'],
    });
    React.useEffect(() => {
        if (!isUpdating) {
            setState({
                volatilityAlerts: notificationPreferences?.['alerts.volatility.push'],
            });
        }
    }, [isUpdating, notificationPreferences]);
    const onValueChange = React.useCallback((newValue) => {
        setState({ volatilityAlerts: newValue });
        updatePreferences({ 'alerts.volatility.push': newValue });
    }, [updatePreferences]);
    if (permissionState === NotificationsPermissionState.Enabled && typeof state.volatilityAlerts === 'boolean') {
        return (<View testID="AlertSection">
        <SectionHeader horizontalMargins largeVerticalMargins>
          Alerts
        </SectionHeader>
        <CardView noMarginTop noMarginBottom>
          <SettingsItemSwitch title="Volatility alerts" onValueChange={onValueChange} value={state.volatilityAlerts} description="Notify me whenever the price of shares in my portfolio or watchlist move more than 5%"/>
        </CardView>
      </View>);
    }
    return null;
};
const AlertSectionWrapper = () => {
    const hasVolatilityAlertFeature = useAppSelector((store) => selectFeatureFlag(store, 'volatility_alert').value);
    if (hasVolatilityAlertFeature) {
        return <AlertSection />;
    }
    return null;
};
export default React.memo(AlertSectionWrapper);
